/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubmissionAdditionalTerms
 */
export interface SubmissionAdditionalTerms {
}

/**
 * Check if a given object implements the SubmissionAdditionalTerms interface.
 */
export function instanceOfSubmissionAdditionalTerms(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SubmissionAdditionalTermsFromJSON(json: any): SubmissionAdditionalTerms {
    return SubmissionAdditionalTermsFromJSONTyped(json, false);
}

export function SubmissionAdditionalTermsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmissionAdditionalTerms {
    return json;
}

export function SubmissionAdditionalTermsToJSON(value?: SubmissionAdditionalTerms | null): any {
    return value;
}

